import { useState } from 'react'
import { ActivityIndicator } from 'react-native'

import { useQueryClient } from '@tanstack/react-query'
import { Button, Icon, SH1, Stack, XStack } from '@zet/design-system'
import { Select } from '@zet/design-system/select'
import { i18n } from '@zet/my-teams/src/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'
import { FlatList } from 'react-native-gesture-handler'

import { IMyTeamsEarningsFiltersModal } from '../../../api/earnings/types'
import useMyTeamsEarningsStore from '../store/myTeamsEarnings'
import { TeamEarningsFilterListItem } from './teamEarningsFilterListItem'

export const EarningsFiltersList = ({
  type,
  filterLabel,
  filterIcon,
  selectedFilters,
  setSelectedFilters,
  setIsBottomSheetVisible,
  filterName,
}: IMyTeamsEarningsFiltersModal) => {
  const queryClient = useQueryClient()
  const [optionSelected, setOptionSelected] = useState<string[] | null>(
    selectedFilters?.filters?.find((filter) => filter.name === filterName)
      ?.value || null
  )
  const myTeamsEarningsFilters = useMyTeamsEarningsStore(
    (state) => state.myTeamsEarningsFilters
  )

  const clearFilters = () => {
    const newFilters = selectedFilters?.filters?.filter(
      (filter) => filter?.name !== filterName
    )
    setSelectedFilters({ ...selectedFilters, filters: newFilters })
    queryClient.invalidateQueries({ queryKey: ['teamEarnings'] })
    setIsBottomSheetVisible()
  }

  const handlePress = () => {
    const newFilters =
      selectedFilters?.filters?.filter(
        (filter) => filter?.name !== filterName
      ) || []
    newFilters?.push({
      name: filterName,
      value: optionSelected || [],
    })
    setSelectedFilters({
      ...selectedFilters,
      filters: newFilters,
    })
    setIsBottomSheetVisible()
  }

  return (
    <Stack>
      <Stack className="bg-white">
        <XStack className="border-grays-30 items-center border-b px-3 pb-2">
          <Icon type={filterIcon} size={24} />
          <SH1 className="text-grays-80 ml-2">{filterLabel}</SH1>
        </XStack>
        <Select
          mode={'multi'}
          onChange={setOptionSelected}
          value={optionSelected}
        >
          <Stack style={{ maxHeight: DEVICE_HEIGHT * 0.6 }}>
            <FlatList
              className="w-screen bg-white px-3"
              data={
                myTeamsEarningsFilters ? myTeamsEarningsFilters[filterName] : []
              }
              renderItem={({ item, index }) => (
                <TeamEarningsFilterListItem
                  key={index}
                  label={item.label}
                  name={
                    isNaN(Number(item?.value))
                      ? item?.value
                      : Number(item?.value)
                  }
                  selectedValue={optionSelected}
                />
              )}
              ListEmptyComponent={
                // TODO: handle empty list
                <ActivityIndicator />
              }
              showsHorizontalScrollIndicator={false}
            />
          </Stack>
        </Select>

        <Stack className="mt-4/2 border-grays-30 border-t px-3 py-3  ">
          <XStack className="justify-between">
            <Button
              className="bg-grays-20 mr-2 flex-grow"
              size={'lg'}
              textOnly={true}
              onPress={clearFilters}
            >
              {i18n.t('teamEarningsFilter.clear')}
            </Button>
            <Button
              onPress={handlePress}
              className="ml-2 flex-grow"
              size={'lg'}
              disabled={!optionSelected?.length}
            >
              {i18n.t('teamEarningsFilter.apply')}
            </Button>
          </XStack>
        </Stack>
      </Stack>
    </Stack>
  )
}
